$(function () {
    // Form Select with Tabs

    function selectTab(tabs, val) {
        tabs.find('.select-tab').attr('style', 'display:none !important');
        tabs.find('input,select,textarea').prop('disabled', true);
        tabs.find('.selectize').each((i, el) => el.selectize && el.selectize.disable());

        if (tabs.find('[data-select-tab="' + val + '"]').length) {
            tabs.attr('style', 'display:block !important');

            var tab = tabs.find('[data-select-tab="' + val + '"]');
            tab.attr('style', 'display:block !important');
            tab.find('input,select,textarea').prop('disabled', false);
            tab.find('.selectize').each((i, el) => el.selectize && el.selectize.enable());
        } else {
            tabs.attr('style', 'display:none !important');
        }
    }
    $('.select-tabs').each(function () {
        let tabs = $($(this).attr('data-select-tabs'));

        selectTab(tabs, $(this).val());

        $(this).on('change', function () {
            selectTab(tabs, $(this).find(':selected').data('select-tab-value') || $(this).val());
        });

        selectTab(tabs, $(this).find(':selected').data('select-tab-value') || $(this).val());
    });
});
